import createNetworkingClient from 'utils/networking-client';
import { devLog } from 'utils/dev-utils';
import { StatusCodes } from 'http-status-codes';
import PERMISSIONS from '../../constants/consents/permissionTypes';
import { isConsentsCreateAction } from '../../apps/Onboarding/shared/onboardingUtils';

export const completeProfile = ({ data }) => {
  return new Promise((resolve, reject) => {
    const url = '/onboarding/complete_profile';

    const payload = {
      ...data,
      // react_onboarding flag is used by the api endpoint to determine the correct response
      // data for this XHR call
      react_onboarding: true
    };

    createNetworkingClient()
      .post(url, payload, { headers: { Accept: 'text/javascript' } })
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          resolve(response.data);
        } else {
          devLog(response.error);
          reject(response.error);
        }
      })
      .catch((e) => {
        devLog(e);
        reject(e);
      });
  });
};

export const facebookFriendsNextStep = () => {
  return new Promise((resolve, reject) => {
    createNetworkingClient()
      .get('/onboarding/facebook_friends_next_step')
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          resolve(response.data);
        } else {
          devLog(response.error);
          reject(response.error);
        }
      })
      .catch((e) => {
        devLog(e);
        reject(e);
      });
  });
};

// action - denied or approved
export const postDirectPromotionConsent = ({ action, currentStep }) => {
  return new Promise((resolve, reject) => {
    if (isConsentsCreateAction(action)) {
      const url = '/onboarding/consents';

      const payload = {
        consent: action,
        permission_type: PERMISSIONS.directPromotion,
        // react_onboarding flag is used by the api endpoint to determine the correct response
        // data for this XHR call
        react_onboarding: true,
        current_step: currentStep
      };

      createNetworkingClient()
        .post(url, payload, { headers: { Accept: 'text/javascript' } })
        .then((response) => {
          if (response?.status === StatusCodes.OK) {
            resolve(response.data);
          } else {
            devLog(response.error);
            reject(response.error);
          }
        })
        .catch((e) => {
          devLog(e);
          reject(e);
        });
    } else {
      reject(new Error(`incompatible action type - ${action}`));
    }
  });
};

export default {
  completeProfile,
  facebookFriendsNextStep,
  postDirectPromotionConsent
};
